import React from 'react';
import { useStores } from '../stores/context';
import '../App.css';

const Auth = () => {
    const { authStore } = useStores();
    let year = new Date().getFullYear();

    return (
        <div>
            <div className="login">
                <div className="logo">
                    <img alt="MAN Logo" src={process.env.REACT_APP_MAN_LOGO_URL} />
                </div>
                <div className="login-box">
                    <div>
                        <p>Sign in to MAN FOTA Admin</p>
                        <button className="login-button" onClick={authStore.login}>
                            Sign in
                        </button>
                        {authStore.error && <p className="error-message">{authStore.error.error_description}</p>}
                    </div>
                </div>
                <p className="footer" >
                    &copy; {year} <a className="footer" href="https://man.eu">man.eu</a> – All rights reserved
                </p>
            </div>
        </div>
    );
};

export default Auth;
